// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-260427-1/static/css/" + chunkId + "." + "c822a367" + ".chunk.css";
};